import React from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import router from "./Router";
import {} from "./i18n/i18n";
import { AuthProvider } from "./context/auth-context";
import { UserProvider } from "./context/user-context";
import { RequestInterceptor } from "./config/request-interceptor";
import { ToastProvider } from "./context/toast-context";
import Toast from "./components/Toast";
import SentryErrorBoundary from "./components/SentryErrorBoundary";

const App = () => {

  return (
    <SentryErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <UserProvider>
            <RequestInterceptor />
            <RouterProvider router={router} />
          </UserProvider>
        </AuthProvider>
        <Toast />
      </ToastProvider>
    </SentryErrorBoundary>
  );
};

export default App;
